"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Notification_1 = require("../Notification");
var react_1 = require("@monaco-editor/react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var BacsResponseTable = /** @class */ (function (_super) {
    __extends(BacsResponseTable, _super);
    function BacsResponseTable(props) {
        var _this = _super.call(this, props) || this;
        _this.renderTableBody = function (bacsResponses) {
            bacsResponses.sort(function (bacsResponse1, bacsResponse2) { return bacsResponse1.id - bacsResponse2.id; });
            return bacsResponses.map(function (bacsResponse) { return _this.renderBacsResponseRow(bacsResponse); });
        };
        _this.prepareToShowBacsDocument = function (event) {
            var idOfDocument = event.currentTarget.id;
            _this.supportPortalService
                .getBacsDocumenById(idOfDocument)
                .subscribe(function (bacsDocument) {
                _this.setState({ currentDocumentToPreview: bacsDocument });
            }, function (e) {
                console.log("Error while retrieving bacsDocument: " + e);
            }, function () { return _this.toggleBacsResponseDocument(); });
        };
        _this.state = {
            bacsDocumentPreviewVisible: false
        };
        _this.prepareToShowBacsDocument = _this.prepareToShowBacsDocument.bind(_this);
        _this.toggleBacsResponseDocument = _this.toggleBacsResponseDocument.bind(_this);
        return _this;
    }
    BacsResponseTable.prototype.render = function () {
        if (this.props.loading) {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
        else if (this.props.bacsResponses && this.props.bacsResponses.length > 0) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [this.state.currentDocumentToPreview && this.renderDocumentViewer(), (0, jsx_runtime_1.jsx)("div", { className: "row mb-5", children: (0, jsx_runtime_1.jsxs)("div", { className: "col-12 table-responsive panel-border px-4", children: [(0, jsx_runtime_1.jsx)("b", { className: "pl-1", children: "BACS Responses" }), (0, jsx_runtime_1.jsxs)("table", { className: "table table-hover table-sm table-bordered mt-3", children: [(0, jsx_runtime_1.jsx)("thead", { children: this.renderTableHeader() }), (0, jsx_runtime_1.jsx)("tbody", { children: this.renderTableBody(this.props.bacsResponses) })] })] }) })] }));
        }
        else {
            return (0, jsx_runtime_1.jsx)("h3", { className: "panel-border px-4", children: "No BACS Responses found!" });
        }
    };
    BacsResponseTable.prototype.renderTableHeader = function () {
        return ((0, jsx_runtime_1.jsxs)("tr", { className: "table-active", children: [(0, jsx_runtime_1.jsx)("th", { children: "ID" }), (0, jsx_runtime_1.jsx)("th", { children: "Mandate ID" }), (0, jsx_runtime_1.jsx)("th", { children: "Payment Request ID" }), (0, jsx_runtime_1.jsx)("th", { children: "Mandate Reference" }), (0, jsx_runtime_1.jsx)("th", { children: "Type" }), (0, jsx_runtime_1.jsx)("th", { children: "Code" }), (0, jsx_runtime_1.jsx)("th", { children: "Date Received" }), (0, jsx_runtime_1.jsx)("th", { children: "Date Processed" }), (0, jsx_runtime_1.jsx)("th", { children: "Response Message" })] }));
    };
    BacsResponseTable.prototype.renderBacsResponseRow = function (bacsResponse) {
        return ((0, jsx_runtime_1.jsxs)("tr", { className: "pb-0", children: [(0, jsx_runtime_1.jsx)("td", { children: bacsResponse.id }), (0, jsx_runtime_1.jsx)("td", { children: bacsResponse.mandateId }), (0, jsx_runtime_1.jsx)("td", { children: bacsResponse.paymentRequestId }), (0, jsx_runtime_1.jsx)("td", { children: bacsResponse.mandateReference }), (0, jsx_runtime_1.jsx)("td", { children: bacsResponse.type }), (0, jsx_runtime_1.jsxs)("td", { children: [bacsResponse.code, " - ", bacsResponse.bacsReason] }), (0, jsx_runtime_1.jsx)("td", { children: bacsResponse.receivedDate }), (0, jsx_runtime_1.jsx)("td", { children: bacsResponse.processedDate }), (0, jsx_runtime_1.jsx)("td", { children: bacsResponse.mongoId &&
                        (0, jsx_runtime_1.jsx)("a", { className: "d-block text-primary on-hover-underline", id: bacsResponse.mongoId.toString(), onClick: this.prepareToShowBacsDocument, children: "View JSON" }) })] }));
    };
    BacsResponseTable.prototype.toggleBacsResponseDocument = function () {
        this.setState(function (prevState) { return ({ bacsDocumentPreviewVisible: !prevState.bacsDocumentPreviewVisible }); });
    };
    BacsResponseTable.prototype.renderDocumentViewer = function () {
        var jsonBody = JSON.stringify(this.state.currentDocumentToPreview, null, 4);
        return ((0, jsx_runtime_1.jsx)(Notification_1.default, { show: this.state.bacsDocumentPreviewVisible, hide: this.toggleBacsResponseDocument, title: "BACS Document", body: ((0, jsx_runtime_1.jsx)(react_1.default, { height: "100%", width: "100%", language: "json", value: jsonBody, onMount: function (editor, monaco) { return editor.focus(); } })), style: {
                maxHeight: "100%",
                height: "100%",
                margin: "0",
                maxWidth: "100%",
                width: "100%"
            } }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], BacsResponseTable.prototype, "supportPortalService", void 0);
    BacsResponseTable = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], BacsResponseTable);
    return BacsResponseTable;
}(React.Component));
exports.default = BacsResponseTable;
//# sourceMappingURL=BacsResponseTable.js.map